import { Link } from "react-router-dom"
import "./guide.css"

export const GuideBtn = (props) => {
  return (
    <>
      <div className="d-flex justify-content-center">
          <Link to={`/guide/${props.city.toLowerCase()}`} className="btn-a">{props.city}</Link>         
      </div>    
    </>
  )
}